import { TaskType } from "../types";

export const getSelectableTaskTypes = (taskTypes: TaskType[]) =>
    taskTypes.filter(
        (taskType) => taskType.isEnabled && !taskType.isSystemDefault,
    );

export const getSelectableTaskTypeId = (
    taskTypes: TaskType[],
    taskTypeId?: string | null,
) =>
    taskTypeId &&
    getSelectableTaskTypes(taskTypes).some(
        (taskType) => taskType.id === taskTypeId,
    )
        ? taskTypeId
        : undefined;
